import React from 'react';

import Icon from '../../common/Icon';

import { Button, Wrapper } from './styled/CallResultPopupCloseButtonStyled';

function CloseButton(props: { onClose: () => void }) {
    return (
        <Wrapper data-testid="CloseButton">
            <Button onClick={props.onClose}>
                <Icon name="Cross" size={11} />
            </Button>
        </Wrapper>
    );
}

export default CloseButton;
